
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBulbOff as ObiLightBulbOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-bulb-off.js';
 
 
 

 
 export const ObiLightBulbOff = createComponent({
   react: React,
   tagName: 'obi-light-bulb-off',
   elementClass: ObiLightBulbOffElement,
   events: {
     
   }
  });
 
 